module.exports = __webpack_public_path__ + "img/glasses-detail1.2f0be154.png";